<template>
    <div>
        <filter-group/>
        <section class="timetable">
           
            <h2 class="timetable__title" v-show="
                (filteredImtOchGroup.length < 1) 
                    && (filteredImtVechGroup.length < 1) 
                    && (filteredIptoOchGroup.length < 1) 
                    && (filteredIptoVechGroup.length < 1) 
                    && ((Number(selectedLevel) === 0) || Number(selectedForm) === 0 || Number(selectedKurs) === 0) 
                    && inputGroupName.length === 0 
                    && inputPrepodSurname.length === 0
                    && isVacationSeason.length === 0
                ">Уровень образования и курс или преподаватель не выбраны</h2>
            <h2 class="timetable__title" v-show="
                (filteredImtOchGroup.length < 1) 
                    && (filteredImtVechGroup.length < 1) 
                    && (filteredIptoOchGroup.length < 1) 
                    && (filteredIptoVechGroup.length < 1) 
                    && ((Number(selectedLevel) === 0) || Number(selectedForm) === 0 || Number(selectedKurs) === 0) 
                    && inputGroupName.length === 0 
                    && inputPrepodSurname.length === 0
                    && isVacationSeason.length === 'winter'
            ">
                Зимние каникулы
            </h2>
            <h2 class="timetable__title" v-show="
                (filteredImtOchGroup.length < 1) 
                    && (filteredImtVechGroup.length < 1) 
                    && (filteredIptoOchGroup.length < 1) 
                    && (filteredIptoVechGroup.length < 1) 
                    && ((Number(selectedLevel) === 0) || Number(selectedForm) === 0 || Number(selectedKurs) === 0) 
                    && inputGroupName.length === 0 
                    && inputPrepodSurname.length === 0
                    && isVacationSeason.length === 'summer'
            ">
                Летние каникулы
            </h2>
            <h2 class="timetable__title" v-show="
                (filteredImtOchGroup.length < 1) 
                && (filteredImtVechGroup.length < 1) 
                && (filteredIptoOchGroup.length < 1) 
                && (filteredIptoVechGroup.length < 1) 
                && ((Number(selectedLevel) > 0) || Number(selectedForm) > 0 || Number(selectedKurs) > 0 ||inputGroupName.length > 0)
                ">Группы не найдены</h2>
            <ul class="timetable__list-institutes institutes container">
                <li class="institutes__item item row" v-if="((filteredImtOchGroup.length > 0) || (filteredImtVechGroup.length > 0))">
                    <div class="item__conteiner-title col-12 col-xl-4">
                        <h2 class="item__title-institute">Институт медиатехнологий</h2>
                    </div>
                    <div class="col-12 col-xl-8 container">
                        <ul class="item__list-institute institute row" v-if="filteredImtOchGroup.length > 0">
                            <h1 class="item__title-institute" style="padding-bottom: 10px;font-size: 28px;text-align: center;">Очная форма</h1>
                            <li class="institute__item group col-6 col-md-4 " v-for="group in filteredImtOchGroup" :key="group">
                                <router-link :to="'/group/'+ group" class="btn-reset btn-group col-md-6 col-ls-4">{{group}}</router-link>
                            </li>
                        </ul>
                        <ul class="item__list-institute institute row" v-if="filteredImtVechGroup.length > 0">
                            <h1 class="item__title-institute" style="padding-bottom: 10px;font-size: 28px;text-align: center;">Очно-заочная форма</h1>
                            <li class="institute__item group col-6 col-md-4 " v-for="group in filteredImtVechGroup" :key="group">
                                <router-link :to="'/group/'+ group" class="btn-reset btn-group col-md-6 col-ls-4">{{group}}</router-link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li class="institutes__item item row" v-if="((filteredIptoOchGroup.length > 0) || (filteredIptoVechGroup.length > 0))">
                    <div class="item__conteiner-title col-12 col-xl-4">
                        <h2 class="item__title-institute">Институт полиграфических технологий и оборудования</h2>
                    </div>
                    <div class="col-12 col-xl-8 container">
                        <ul class="item__list-institute institute row" v-if="filteredIptoOchGroup.length > 0">
                            <h1 class="item__title-institute" style="padding-bottom: 10px;font-size: 28px;text-align: center;">Очная форма</h1>
                            <li class="institute__item group col-6 col-md-4 " v-for="group in filteredIptoOchGroup" :key="group">
                                <router-link :to="'/group/'+ group" class="btn-reset btn-group col-md-6 col-ls-4">{{group}}</router-link>
                            </li>
                        </ul>
                        <ul class="item__list-institute institute row" v-if="filteredIptoVechGroup.length > 0">
                            <h1 class="item__title-institute" style="padding-bottom: 10px;font-size: 28px;text-align: center;">Очно-заочная форма</h1>
                            <li class="institute__item group col-6 col-md-4 " v-for="group in filteredIptoVechGroup" :key="group">
                                <router-link :to="'/group/'+ group" class="btn-reset btn-group col-md-6 col-ls-4">{{group}}</router-link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li class="institutes__item item row" v-if="((filteredImtOchPrepod.length > 0))">
                    <div class="item__conteiner-title col-12 col-xl-4">
                        <h2 class="item__title-institute">Преподаватели ИМТ и ИПТО</h2>
                    </div>
                    <div class="col-12 col-xl-8 container">
                        <ul class="item__list-institute institute row" v-if="filteredImtOchPrepod.length > 0">
                            <!--<h1 class="item__title-institute" style="padding-bottom: 10px;font-size: 28px;text-align: center;">Список преподавателей ИМТ и ИПТО</h1>-->
                            <li class="institute__item group col-6 col-md-4 " v-for="teacher in filteredImtOchPrepod" :key="teacher">
                                <router-link :to="'/teacher/'+ teacher" class="btn-reset btn-group col-md-6 col-ls-4">{{teacher}}</router-link>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>

import {mapGetters, mapState} from "vuex";
import FilterGroup from '@/components/FilterGroup.vue'

export default{
    components:{
        FilterGroup,
    },
    computed: {
    ...mapState(['selectedLevel', 'selectedForm', 'selectedKurs', 'inputGroupName', 'inputPrepodSurname']),
    ...mapGetters(['isVacationSeason','semestrIptoOchGroups', 'semestrImtOchGroups', 'semestrIptoVechGroups', 'semestrImtVechGroups', 'semestrImtIptoOchVechPrepod']),
    
    filteredImtOchGroup(){
        return this.semestrImtOchGroups?.filter(v => {
            let show = true
            
            if (((parseInt(this.selectedLevel) > 0) || (parseInt(this.selectedKurs) > 0) || (parseInt(this.selectedForm) > 0) || (this.inputGroupName.length > 0)) && this.inputPrepodSurname.length === 0){
                if (this.inputGroupName.length > 0){
                    show &&= v.includes(this.inputGroupName.toUpperCase())
                }
                if (parseInt(this.selectedKurs) > 0){
                    show &&= parseInt(v[0]) === parseInt(this.selectedKurs)
                }
                if (parseInt(this.selectedForm) === 2){
                    show &&= v.includes('ГИД') && v.includes('ТИД')
                }
                if (parseInt(this.selectedLevel) === 1){
                    show &&= !v.includes('МГ') && !v.includes('ГИД-9') && !v.includes('ГИВ-9')
                }
                if (parseInt(this.selectedLevel) === 2){
                    show &&= v.includes('МГ')
                }
                if (parseInt(this.selectedLevel) === 3){
                    show &&= v.includes('ГИД-9')
                }

            } else{
                show &&= 0
            }
            return show
        }).sort((a, b)=>{
            let reg = /\d{1}-[А-Я]+-/
            if ( Number(a.slice(a.match(reg)[0].length)) > Number(b.slice(b.match(reg)[0].length))) return 1
            else if ( Number(a.slice(a.match(reg)[0].length)) < Number(b.slice(b.match(reg)[0].length))) return -1
            else{return 0}
        })
    },
    filteredIptoOchGroup(){
        return this.semestrIptoOchGroups?.filter(v => {
            let show = true
            
            if (((parseInt(this.selectedLevel) > 0) || (parseInt(this.selectedKurs) > 0) || (parseInt(this.selectedForm) > 0) || (this.inputGroupName.length > 0)) && this.inputPrepodSurname.length === 0){
                if (this.inputGroupName.length > 0){
                    show &&= v.includes(this.inputGroupName.toUpperCase())
                }
                if (parseInt(this.selectedKurs) > 0){
                    show &&= parseInt(v[0]) === parseInt(this.selectedKurs)
                }
                if (parseInt(this.selectedForm) === 2){
                    show &&= v.includes('ГИД') && v.includes('ТИД')
                }
                if (parseInt(this.selectedLevel) === 1){
                    show &&= !v.includes('МГ') && !v.includes('ГИД-9') && !v.includes('ГИВ-9')
                }
                if (parseInt(this.selectedLevel) === 2){
                    show &&= v.includes('МГ')
                }
                if (parseInt(this.selectedLevel) === 3){
                    show &&= v.includes('ГИД-9')
                }
            } else{
                show &&= 0
            }
            return show
        }).sort((a, b)=>{
            let reg = /\d{1}-[А-Я]+-/
            if ( Number(a.slice(a.match(reg)[0].length)) > Number(b.slice(b.match(reg)[0].length))) return 1
            else if ( Number(a.slice(a.match(reg)[0].length)) < Number(b.slice(b.match(reg)[0].length))) return -1
            else{return 0}
        })
    },
    filteredImtVechGroup(){
        return this.semestrImtVechGroups?.filter(v => {
            let show = true
            
            if (((parseInt(this.selectedLevel) > 0) || (parseInt(this.selectedKurs) > 0) || (parseInt(this.selectedForm) > 0) || (this.inputGroupName.length > 0)) && this.inputPrepodSurname.length === 0){
                if (this.inputGroupName.length > 0){
                    show &&= v.includes(this.inputGroupName.toUpperCase())
                }
                if (parseInt(this.selectedKurs) > 0){
                    show &&= parseInt(v[0]) === parseInt(this.selectedKurs)
                }
                if (parseInt(this.selectedForm) === 1){
                    show &&= !v.includes('ГИВ') && !v.includes('ТИВ')
                }
                if (parseInt(this.selectedLevel) === 1){
                    show &&= !v.includes('МГ') && !v.includes('ГИД-9') && !v.includes('ГИВ-9') && !v.includes('1-ГИВ-5') && !v.includes('2-ГИВ-5') && !v.includes('3-ГИВ-5') && !v.includes('4-ГИВ-5')
                }
                if (parseInt(this.selectedLevel) === 2){
                    show &&= v.includes('МГ')
                }
                if (parseInt(this.selectedLevel) === 3){
                    show &&= v.includes('ГИВ-9')
                }
            } else{
                show &&= 0
            }
            return show
        }).sort((a, b)=>{
            let reg = /\d{1}-[А-Я]+-/
            if ( Number(a.slice(a.match(reg)[0].length)) > Number(b.slice(b.match(reg)[0].length))) return 1
            else if ( Number(a.slice(a.match(reg)[0].length)) < Number(b.slice(b.match(reg)[0].length))) return -1
            else{return 0}
        })
    },
    filteredIptoVechGroup(){
        return this.semestrIptoVechGroups?.filter(v => {
            let show = true
            
            if (((parseInt(this.selectedLevel) > 0) || (parseInt(this.selectedKurs) > 0) || (parseInt(this.selectedForm) > 0) || (this.inputGroupName.length > 0)) && this.inputPrepodSurname.length === 0){
                if (this.inputGroupName.length > 0){
                    show &&= v.includes(this.inputGroupName.toUpperCase())
                }
                if (parseInt(this.selectedKurs) > 0){
                    show &&= parseInt(v[0]) === parseInt(this.selectedKurs)
                }
                if (parseInt(this.selectedForm) === 1){
                    show &&= !v.includes('ГИВ') && !v.includes('ТИВ')
                }
                if (parseInt(this.selectedLevel) === 1){
                    show &&= !v.includes('МГ') && !v.includes('ГИД-9') && !v.includes('ГИВ-9')
                }
                if (parseInt(this.selectedLevel) === 2){
                    show &&= v.includes('МГ')
                }
                if (parseInt(this.selectedLevel) === 3){
                    show &&= v.includes('ГИД-9')
                }
            } else{
                show &&= 0
            }
            return show
        }).sort((a, b)=>{
            let reg = /\d{1}-[А-Я]+-/
            if ( Number(a.slice(a.match(reg)[0].length)) > Number(b.slice(b.match(reg)[0].length))) return 1
            else if ( Number(a.slice(a.match(reg)[0].length)) < Number(b.slice(b.match(reg)[0].length))) return -1
            else{return 0}
        })
    },
    filteredImtOchPrepod(){
        //console.log(this.semestrImtIptoOchVechPrepod)
        //console.log(this.inputPrepodSurname)
        return this.semestrImtIptoOchVechPrepod?.filter(v => {
            let show = true;
            if (((parseInt(this.selectedLevel) === 0) || (parseInt(this.selectedKurs) === 0) || (parseInt(this.selectedForm) === 0) || (this.inputGroupName.length === 0)) && this.inputPrepodSurname.length > 0){
                if (this.inputPrepodSurname.length > 0){
                    //console.log(v.toLowerCase(), this.inputPrepodSurname.toLowerCase())
                    show &&= v.toLowerCase().includes(this.inputPrepodSurname.toLowerCase())
                }
            } else {
                show &&= 0
            }
            return show
        }).sort((a, b) => a.localeCompare(b));
    }
  },
}
</script>
